import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";

export default {
  fetchCrmMetrics(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/kpi/commerce/crm-metrics?${p}`);
  },
  fetchEmployeeActivity(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/kpi/commerce/employee-activity?${p}`);
  },
  fetchRadioDashboard(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/kpi/radio/dashboard?${p}`);
  },
  fetchNetworkMaintenanceDashboard(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/kpi/network-maintenance/dashboard?${p}`);
  },
  fetchSalesDashboard(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/kpi/sales/dashboard?${p}`);
  },
  fetchPowerDashboard(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/kpi/power/dashboard?${p}`);
  },
  exportRadioDashboard(params) {
    const p = paramsFactory({ ...params, export: "excel" });
    return api.get(`/api/v1/kpi/radio/dashboard?${p}`, { responseType: "blob" });
  },
  exportNetworkMaintenanceDashboard(params) {
    const p = paramsFactory({ ...params, export: "excel" });
    return api.get(`/api/v1/kpi/network-maintenance/dashboard?${p}`, {
      responseType: "blob",
    });
  },
  exportPowerDashboard(params) {
    const p = paramsFactory({ ...params, export: "excel" });
    return api.get(`/api/v1/kpi/power/dashboard?${p}`, { responseType: "blob" });
  },
  exportCommerceEmployeeActivity(params) {
    const p = paramsFactory({ ...params, export: "excel" });
    return api.get(`/api/v1/kpi/commerce/employee-activity?${p}`, {
      responseType: "blob",
    });
  },
};
